export default {
  ActionConfirm: "Confirm action",
  ActivatePromocode: "Activate promo code",
  AddFile: "Click to attach file",
  AddToFavorites: "Add to Favorites",
  "Andar Bahar": "Andar Bahar",
  ApplyFilter: "Apply filter",
  AppsPage: {
    blocks: {
      descriptionOne: "No need to look for actual mirrors",
      descriptionThree: "Personal notifications about all promotions, tournaments and draws",
      descriptionTwo: "Unique promotions and offers for app users",
      titleOne: "OLYMP is always at hand",
      titleThree: "Stay up to date with all events and offers",
      titleTwo: "Exclusive promotions and tournaments"
    },
    dontWorry: "Don't worry, it's safe",
    howToInstall: "How to install",
    installAndroid: "Download for Android",
    installIos: "Install for iOS",
    installIsSafe: "Installation is safe",
    qrText: "Point your camera at the QR code to download the app",
    safeDescription: "We cannot post the app on the Play Market due to Google's gambling policy. To install, follow the instructions",
    seo: {
      all: {
        block_one: {
          description: "{platform} is a modern platform for virtual betting and gambling with a wide range of entertainment. We pay special attention to the comfort of users, which is why our online platform can be visited from any device - both from a computer and from a smartphone. Olymp casino mobile app is adapted for all modern phones that run on popular operating systems - Android and iOS. Gambling enthusiasts can use the full potential of the Internet platform anywhere at a convenient time for them.",
          title: "{platform} mobile app"
        },
        block_three: {
          description: "Any player who has downloaded the app and registered in it has at their disposal all the functionality of the site and a complete set of tools. What exactly is available in the mobile app? Through your personal account you can:",
          list: {
            five: "Explore the history of financial transactions on the gaming account - withdrawal orders, payments and bets.",
            four: "Use bonuses - welcome package and other gifts.",
            one: "Set up a profile - add a phone number or email address, fill in information about yourself and change it.",
            three: "Follow the mailing from the casino in messages.",
            two: "Check the balance, deposit it by any convenient method, withdraw prize amounts and receive instant cashback."
          },
          text: "You can play online at the Olymp casino and place bets immediately after the registration procedure. You just need to make a minimum deposit and choose the entertainment you like — our app features slot machines, lotteries, fast, sports and classic games, live casino, sports betting and various tournaments. If you have any questions during an online session in the Olymp Casino application, technical support will come to the rescue. It is enough to open a chat and leave a message in a special form.",
          title: "Functional"
        },
        block_two: {
          description: "App stores - Google Play Market, AppGallery and other markets - have different policies regarding gambling and do not always place the necessary software in their catalogs. We have simplified the search process for you and placed the Olymp casino mobile app for all operating systems in the public domain - it is easy to download it directly from our official site. You can choose one of the following action algorithms:",
          list: {
            one: "Use a computer. To do this, launch the official {platform} portal through any browser or open a working mirror through a search engine. There you will find a page with \"Install for iOS\" and \"Download for Android\" buttons. Click on the appropriate option and scan the QR code using your phone's camera. A link will be displayed on its screen - follow it. If you are using an iPhone, you will be redirected to our app in the App Store where you can download it. If you have Android, you need to grant permission to install the application and wait for it to finish.",
            two: "Use mobile devices. Go to the {platformSite} site - the mobile version of the Olymp site will open. To download the app for free, first select the one you need from the two download buttons depending on the OS of your smartphone. Don't forget to check your phone's 'Settings' first and allow unknown files to be installed - it's safe. The app will download in minutes"
          },
          text: "Click \"Log in\" and proceed to authorization. If you haven't got an account at {platform} yet, now is the time to do it. Enter your phone number or e-mail in the appropriate fields, come up with a good password and confirm the action.",
          title: "Where to download the app"
        }
      },
      android: {
        block_four: {
          description: "The {platform} mobile app works in english, kazakh, uzbek, kyrgyz and russian - you can change it at any time. The app has been adapted for use via phone with maximum comfort - all interface elements have been moved here, taking into account the size of mobile screens. Each authorized smartphone owner has access to all the functions of the desktop version of the site:",
          list: {
            five: "Private messages.",
            four: "Payments history , bets and withdrawal orders.",
            one: "Profile settings.",
            three: "Promo codes and gifts - free spins, free bets and deposit bonuses.",
            two: "Operations with a game account - deposit, withdrawal and instant cashback."
          },
          text: "And most importantly, via your phone or tablet, you can try out any games that interest you, try your luck in sports betting and take part in promotions and tournaments. Casino Olymp will always be at your fingertips, and with personalised alerts you won't miss out on exclusive offers.",
          title: "Functional"
        },
        block_one: {
          description: "{platform} has a rich collection of gambling entertainment for everyone who prefers to relax with pleasure, regardless of location. Sports betting and lotteries, fast and bet games, live casinos and slots - gaming software is available to you right from your phone! Owners of smartphones based on the Android operating system can afford everything - especially for you, we have developed a special Olymp mobile app for Android. Deposit your personal account via your phone or tablet, launch your favorite slot machines and slots online and enjoy the process.",
          title: "Olymp Casino App for Android "
        },
        block_three: {
          description: "Are you going to download the Olymp app for Android for free from the official site? You need to prepare your mobile device for installing APK files. To get started, enable the necessary permissions:",
          list: {
            four: "When the request «Allow installation from this source» appears on the screen, click the button to start the download.",
            one: "Go to «Settings» on your smartphone and find «Apps».",
            three: "Provide access to installing unknown apps.",
            two: "Open the \"Permissions\" menu."
          },
          text: "You can download the Olymp app for Android via the desktop version of the portal using a QR code. It will appear right on the page - all you have to do is point your smartphone camera at the code and wait for the download link. With the mobile version of Olymp Casino, the installation process comes down to a few simple steps. To download the app via smartphone, open the mobile version of the portal in your browser. There you will see the \"Download App\" button. Click on it - and you will see the inscription \"Download\". Feel free to click on the installation links - it's safe, the file will be downloaded from a reliable source. Ready! You can enjoy all the benefits of the mobile app. Now you are relieved of the need to look for working mirrors or install a VPN - the Olymp Casino mobile app will work as long as you have Internet access. If this app needs to be updated to the latest version, please do so to make sure everything works properly.",
          title: "Installation instructions"
        },
        block_two: {
          description: "The {platform} Android mobile app is your guide to the world of better gambling and sports betting. Where to download it? Android mobile marketplaces like Google Play Market, AppGallery or any other similar app shop have a specific policy when it comes to gambling. You will only find third party developers there. They have nothing to do with official Olymp Casino site. To find our original app, need to visit the olymp.casino main site on your computer or mobile device.",
          title: "Where to download the app"
        }
      },
      ios: {
        block_one: {
          description: "There are many fans of {platform} gambling among iPhone and iPad owners. Our mobile app for devices based on the iOS operating system opens up a wide range of opportunities for users and provides complete freedom of action. At any time you have in your pocket a huge catalog of entertainment with full online casino functionality. Deposit funds, manage your profile details, cash out prizes of any size, play online and try new things every day. The Olymp Casino mobile app for iOS will help you get as much fun and benefit as you want! To do this, you need to properly “equip” your phone or tablet and move on to entertainment.",
          title: "iOS app Olymp Casino for iPhone"
        },
        block_three: {
          description: "Olymp casino app for iOS devices gives you full access to the entire collection of gambling entertainment on the platform - numerous slots, table, sports and crash games, tables, lotteries, promotions, tournaments. Through your personal account in the mobile app, you can perform any necessary actions:",
          list: {
            five: "View transaction history — all withdrawal orders, transactions and bets.",
            four: "Read messages from the casino.",
            one: "Change personal information in the profile and pass verification.",
            three: "Receive, activate and wager gifts - including a welcome bonus for newcomers.",
            two: "Deposit your account, cash out your winnings and get instant cashback."
          },
          text: "Especially for users of the mobile app, there are many unique offers: do not forget to turn on notifications to stay up to date with all the events and learn about profitable promotions, current draws and exclusive tournaments in a timely manner. It's time to make the deposit, place bets, «test» slot machines and pump your luck. We have made sure that every virtual session in the Olymp casino app gives you only pleasant impressions.",
          title: "Functionality and features"
        },
        block_two: {
          description: "We know how to provide them with the necessary tool for the game efficiently and comfortably for users. The {platform} mobile app is available in the Apple store - it is free. To download the official Olymp app for iOS, you need to get a download link from the App Store. There are two ways to do this - you can choose the one that is more convenient:",
          list: {
            one: "Start the official Olymp casino site on your computer and go to the page with a link to the mobile app. There you will see a QR code - point your device's camera at it and click on the download link.",
            two: "Go to the {platformSite} portal directly through your iOS device — the mobile version will open. To download the Olympus application on iPhone or iPad in this way, just click on the \"Install for iOS\" button. You will be redirected to the App Store and you can start installing the app."
          },
          text: "When downloading is completed, you can create an account in the system or log in if you already have a personal account, and proceed to the most interesting part - {platform} entertainment!",
          title: "Installing the app is easy"
        }
      }
    },
    seoText: "A special SEO text may not be needed on the page for iPhones, but you can try to write a review of the app and optimize for the semantics of the “olimpbet app review” category. Here and there are almost no frequency.",
    seoTitle: "SEO text",
    slider: {
      textEight: "Click on the \"Download app\" button on the site",
      textFive: "Click on the \"Install\" button",
      textFour: "Click on the downloaded app's file",
      textOne: "Click on the \"Download\" button to start downloading",
      textSeven: "Point your phone camera at the QR code and go to the site",
      textSix: "Start the app from your desktop and play",
      textThree: "Allow installation of apps from unknown sources",
      textTwo: "Go to the \"Installing unknown apps\" section "
    },
    slides: {
      allowInstall: "Allow installation from unknown sources",
      cancel: "Cancel",
      download: "Download",
      downloadApp: "Download app",
      downloadIsDone: "Downloading is complete",
      installUnknownApp: "Installing unknown apps",
      isntall: "Install",
      moveToSite: "Go to site",
      myFiles: "My files",
      safeDescription: "Installing apps not from the Play Market. Download the file only from a trusted source",
      settings: "Settings"
    },
    textForMobile: {
      androidAndIos: "for Android and iOS",
      downloadOnAndroid: "Download for Android",
      downloadOnAndroidAndIos: "Download for Android and iOS",
      downloadOnIos: "Download for iOS",
      onAndroid: "for Android",
      onIos: "for iOS"
    },
    title: "Olymp App"
  },
  Aviator: "Aviator",
  Basket: "Bet slip",
  BeforeEndPromotion: "Until the end of the promotion",
  BeforeStartPromotion: "Before the start of the promotion",
  Betgames: "Betgames",
  Bets: "Odds",
  BonusBalanceOff: "You have switched to the main casino balance. Deposit your account and play your favourite games.",
  BonusBalanceOn: "You have switched to the bonus balance.",
  BonusesAndPromotions: "Bonuses and promotions",
  BonusesAndPromotionsSection: "Bonuses and promotions section",
  Categories: "Categories",
  Chat: "Chat",
  CloseMatchTracker: "Close Match Tracker",
  CoefficientChanged: "Odds have changed",
  ContactSupport: "Contact support",
  "Cricket X": "Cricket X",
  DeleteConfirm: "Confirm deletion",
  DeleteConfirmText: "Do you really want to delete previously uploaded files?",
  DeleteFiles: "Delete files",
  DenyReason: "Rejected for reason",
  DocumentAlreadyAttached: "This file is already attached",
  DocumentDoesntMeetRequirements: "The document does not meet the requirements",
  DocumentResolutionTooBig: "Photo resolution too high. Highest supported resolution - {value} Mp",
  DocumentsFilesLimits: "(max. number of files - {fields}, max. file size - {size} MB)",
  DocumentsUploadError: "An error occurred while uploading files -{files}. The rest of the files have been sent for review. You can try downloading these files again",
  DownloadOn: "Download on",
  EuroLanding: {
    activate: "<span>Activate</span><br /> in the “Bonuses” section",
    bonusText: "<span>Freebet</span><b>{freebet}</b><span>for registration!</span>",
    register: "<span>Register</span><br /> on the Olymp Casino website"
  },
  Event: "Event",
  Exclusive: "Exclusive",
  Expires: "Expires",
  ForbidenBonus: "Prizes for the current day have already been received",
  Found: "Found",
  FruityWheel: {
    btn: "Spin",
    title: "Spin and find out your welcome bonus"
  },
  GatesOfOlympus: {
    completeSignIn: "Complete registration now and get a bonus",
    getBonus: "Get bonus",
    spin: "Spin",
    titleFirstLine: "Spin the wheel",
    titleSecondLine: "get bonuses",
    twist: "Spin",
    youWin: "You won",
    yourBonus: "Your bonus"
  },
  GetYourPrizes: "Get your prizes",
  GoldenTimesKz: {
    bonusText: "Congratulations! Your win",
    headTitle: "Claim your bonus <br /> and hit the jackpot!",
    labelText: "Enter your phone number"
  },
  InformationAllPromotions: "Information on all promotions",
  InitialCoefficient: "Initial odds:",
  JetX: "JetX",
  LongTermRates: "Long-term bets",
  MainSite: "Main site",
  MatchTracker: "Match Tracker",
  MaximizeMatchTracker: "Enlarge Match Tracker ",
  MinimizeMatchTracker: "Reduce Match Tracker",
  Mobile: "Mobile",
  MobileAppSetupLanding: {
    app: "/app",
    appText: "Select the menu option /app",
    getLink: "or get the link through our Telegram bot",
    getLinkButton: "Get the Link",
    groups: {
      four: "Stay Updated <br/> by getting notified of all events and promotions",
      one: "<span>100 FS without deposit </span> installation of the mobile app",
      three: "Exclusive <br/> promotions and tournaments",
      two: "No need to search for <br/> mirror sites"
    },
    start: "/start",
    startText: "Launch the Telegram bot by tapping /start",
    successLink: "Link successfully sent",
    text: "Download the Olymp Mobile App and be ready to play anytime",
    title: "<span>100 FS without <br/>deposit </span>for installation of the OLYMP mobile app"
  },
  MobileApplications: "Mobile applications",
  MyDocuments: "My documents",
  NewYearRules: {
    "1": "Promotion period: 20.12.2024 00:00 - 02.01.2025 23:59:59 GMT +5",
    "10": "Aviator freebets",
    "11": "JetX freebets",
    "12": "If you win a bonus on the promo page, the bonus is added to your personal account, the “Bonuses” section, by clicking on the “Go to bonus” button",
    "13": "Activation of added bonuses is available within 3 days",
    "14": "After activation, the deposit must be made within 1 day",
    "15": "Wagering of bonus funds must be completed within 1 day",
    "16": "Detailed conditions for each bonus are available on the “Bonuses” page in your personal account",
    "2": "Every day on the promo page you are given 3 attempts to receive the bonus.",
    "3": "The number of attempts resets to 3 every day during the promotion period at 00:00 GMT +5",
    "4": "To win the bonus, the user should go to the promo page every day and launch the slot machine by clicking on the SPIN button",
    "5": "Each press of SPIN takes one attempt",
    "6": "Winning of bonus and bonus type are determined randomly from:",
    "7": "Bonus on deposit in slots",
    "8": "Free spins in slots",
    "9": "Freebets for sports"
  },
  NezlobLanding: {
    forDeposit: "on deposit",
    title: "The jokes are over!"
  },
  NotCalculated: "Not calculated",
  NotSingleActionCurrentlyHeld: "There are no promotions going on right now",
  OlimpCasino: "Olimp Casino",
  OpenFullVersion: "Open Full Version",
  PaymentMethods: "Payment Methods",
  PlayEveryDay: "Play every day",
  PromoAvailableFrom: "The promotion is available from {date}",
  PromoAvailableFromTo: "The promotion is available from {date1} to {date2}",
  PromoEnded: "The promotion ended in {date}",
  Promotions: "Promotions",
  PromotionsWillDisplayedHere: "Promotions will be displayed here",
  QuestionAndAnswer: "Question - Answer",
  RulesAcceptingBets: "Rules for accepting bets from the OLYMP Bookmaker",
  RulesOfPromotion: "Promotion T&Cs",
  RulesSingle: "Rules",
  SelectTypeSystem: "Select your system type",
  Soon: "Soon",
  Statistics: "Statistics",
  StayTuned: "Stay tuned",
  TableContents: "Table of Contents",
  TheSearchHasNotGivenAnyResults: "The search has not given any results",
  ToDisableYouNeedToConfirmYourPhoneAndEmail: "To disable you need to confirm your phone and e-mail",
  ToMain: "Home",
  ToUp: "To the Top",
  TypeBonusesAndPromotions: "Type of bonuses and promotions",
  UntilTheNextBonus: "Until the next bonus",
  UploadDocuments: "Uploaded files",
  Version: "version",
  WeAreOnSocialMedia: "We're on social media",
  WeOnSocialMediaFull: "We are on social media",
  WorldCup: "2022 World Cup\n",
  YouDataProtected: "Personal data and funds are safe",
  YourBonus: "Your bonus",
  aboutBonus: "More about bonus",
  acceptWithModifiedOdds: "Accept with updated odds",
  acceptWithModifiedTotals: "Accept with updated totals/handicaps",
  accountApprove: "Account protected",
  accountNotApprove: "Account is not protected",
  action: "Action",
  activate: "Activate",
  activateBonus: "Activate bonus",
  activateFastBets: "Activate quick bets",
  activatingPromoCode: "Promo code activation",
  active: "Active",
  activeBonusErr: "To activate a bonus, make a deposit of at least",
  activeWager: "Active wager",
  add: "Add",
  addToBasket: "Add to bet slip",
  addYourFavoriteGames: "Add games to favorites using",
  addingDogeCoin: "Add the Doge coin",
  additionalInfo: "Additional data\n",
  addressCryptoWallet: "Crypto wallet address",
  addressWallet: "Wallet address",
  afterInstallApp: "You received a bonus {0} for installing the app",
  agreeTermsAndConditions: "I agree with {0} and confirm that I am over 18 years old",
  all: "All",
  allDepositMethods: "All deposit methods",
  allGames: "All games",
  allMessages: "Total",
  allMessagesButton: "Go to messages",
  allMessagesText: "All messages",
  allPromo: "All promotions",
  allRequiredFieldsMustBeFilled: "All required fields must be filled out ",
  allTypes: "All types",
  allWithdrawMethods: "All withdrawal methods",
  all_right: "All rights reserved.",
  alreadyHasAccount: "Account already exists",
  always: "Always",
  amountOnAccount: "Amount on account ",
  anUnexpectedErrorOccurred: "An unexpected error occurred!",
  antifraud: {
    five: "Multistage client check (Check by IP, system parameters check, proxy check); Verification of the customer's phone number; Analysis of player behavior by a specialist; The anti-fraud system has more than 100 filters designed for detailed verification of payment data, payment history and user blacklist; The client undergoes final verification by our control service at the withdrawal stage.",
    four: "Main characteristics",
    one: "Fraud protection",
    three: "In cooperation with leading providers of online payment services, we do our best to conduct online business reliably and to ensure the security of our users private information, as well as all payment data. Our ten years of experience in managing databases of payment transactions makes Avento AntiFraud Tool a truly powerful and convenient tool against credit card fraud.",
    two: "Avento AntiFraud Tool is a powerful anti-fraud tool designed to prevent fraudulent online gambling transactions. This allows us to significantly reduce the number of credit card fraud in our gambling establishments."
  },
  app: "Application",
  appOlymp: "Olymp App",
  apply: "Apply",
  approve: "I confirm",
  approvePhoneBySms: "Confirm number via SMS\n",
  approvePhoneByTelegram: "Confirm number via Telegram",
  approved: "Approved\n",
  approvedSecond: "Confirmed",
  approvingWithdraw: "Withdrawal confirmation",
  april: "April",
  areYouSureDeposit: "Are you sure you deposited?",
  areYouSureToDeclineBonus: "Are you sure you want to cancel the bonus?",
  areYouSureYouWantToSell: "Are you sure you want to cash out your bet",
  attach: "Attach documents\n",
  attachDocumentsToVerifyAccount: "Please attach documents to complete verification and for money withdrawal",
  attempt: "No attempts | 1 Attempt | {count} Attempts",
  august: "August",
  authApproveText: "To verify that you are not a robot, click on the 'Confirm' button",
  authFromSocial: "Log in via social networks",
  authorization: "Authorization",
  authorizationRequired: "Paid game requires authorization!",
  availabilityWallet: "Crypto wallet {wallet} is required",
  available: "Available",
  availableBonuses: "Available bonuses",
  availableOnlyGameForMoney: "Only playing for money is available",
  back: "Go back",
  backToHome: "Go back to the main page",
  backToLogin: "Back to login",
  backToOneStep: "Back to step one",
  balance: "Balance",
  balanceAfterTopUp: "Balance after deposit: {value}",
  balanceAfterWithdraw: "Balance after withdrawal: {value}",
  balanceBK: "Bookmaker balance",
  balanceBKRefreshSuccessfully: "Bookmaker balance has been successfully updated",
  balanceCasino: "Casino balance",
  balanceCasinoRefreshSuccessfully: "Casino balance has been successfully updated",
  balanceSwitchByWithoutBalance: "Switching to the bonus balance is done automatically only when playing bonus games, if there are no funds on the real balance",
  balances: "Balances",
  bankCard: "Bank card",
  basketBets: "Bet slip",
  behind: "for",
  bet: "Bet",
  betHistory: "Bets",
  betID: "Bet ID",
  betSoldFor: "Bet cashed out for {count}",
  betsAreSuspended: "Betting is suspended",
  betsNotAccessForBonusBalance: "Sports betting is not available from the bonus balance!",
  bettingHistory: {
    bet: "Bet",
    coefficient: "Odds",
    dataOfBet: "Bet data",
    findOutTheScore: "Find out the score",
    numberAndDateOfBet: "Bet number and date",
    payout: "Payout",
    status: "Status"
  },
  bidAddedToCart: "Bet added to bet slip",
  bidDeletedToCart: "Bet removed from bet slip",
  bonus: "Bonus",
  bonusActivated: "Bonus activated",
  bonusActivation: "Bonus activation",
  bonusBalance: "Bonus balance",
  bonusBalanceOnly: "To play from bonus balance, launch the bonus game",
  bonusCondition: "Bonus conditions",
  bonusNotActivated: "Bonus not activated",
  bonusOnFirstDeposit: "Bonus 100% <br/>for the first deposit",
  bonusQuestion: "Have not received your welcome bonus yet?",
  bonusSport: {
    block1: {
      li1: "Register at olymp.casino.",
      li2: "To activate the bonus, go to the \"Bonuses\" section in your Personal account and activate the offer.",
      li3: "Make a deposit from 500 KZT / 12 000 UZS in one payment.",
      li4: "After deposit, the bonus will be automatically credited and available for betting in the \"Sports\" section of your coupon.",
      title: "How to get your bonus:"
    },
    block2: {
      li1: "The user is entitled to only one bonus.",
      li2: "Free bet can only be used on sports. Your bet slip must be a single bet with odds of at least 3 and a maximum of 10.",
      li3: "The player receives only the winning part to his account.",
      text: "For example: A free bet of 500 on odds of 3. Player gets 3*500-500 = 1000 on the account.",
      title: "Terms and Conditions:"
    },
    block3: {
      li1: "The wagering requirements for the free bet must be met within 7 days, otherwise the bonus will expire.",
      li10: "Olymp.casino has the right to change the terms of the offer, cancel or renew the offer, or decline participation at any time without prior notice.",
      li11: "Olymp.casino may restrict or deny users’ participation in this or any other offer.",
      li12: "Only one bonus is allowed for one customer, family, address, shared computer, shared IP address and any identical account data, including email address, bank account details, credit card information and payment system account. Any abuse of this bonus offer will close the account.",
      li13: "Olymp.casino reserves the right to modify or cancel this offer at any time.",
      li14: "By accepting the bonus, the customer agrees to the bonus terms and conditions, as well as the general terms and conditions of Olymp.casino.",
      li2: "To withdraw a winning, you need to make a minimum deposit of 500 KZT/12,000 UZS and perform a wager x1.",
      li3: "In case of cancellation or refund, the bet is settled as a loss.",
      li4: "In case of a half-loss (Asian handicap and total) - the bet is settled as a loss.",
      li5: "In case of a half-win (Asian handicap and total) - settled as a regular bet, excluding the bet amount.",
      li6: "After the bet is settled, the money is added to your balance.",
      li7: "Free bet cannot be used partially. (i.e. if you have a free bet on 500, you must bet on 500. 250 - 250 for different coupons are not accepted).",
      li8: "Offer cannot be used in combination with other promotional or special offers.",
      li9: "Multiple accounts are not allowed and will suspend the entire account if multiple accounts are found.",
      title: "Other conditions:"
    },
    title: "The best time to join Olymp.Casino is now, because we offer every new user a free bet of 500 KZT / 12 000 UZS for sports"
  },
  bonusTimeLeft: "Time to complete the action",
  bonusWager: "Bonus wager:",
  bonuses: "Bonuses",
  bookmakerShort: "Bookmaker",
  "break": "Break",
  bronze: "Bronze",
  btn: "Cash desk",
  byDefault: "By default",
  byDefaultDown: "By alphabet (A-Z)",
  byDefaultUp: "By alphabet (Z-A)",
  bySport: "By sport",
  cabbage: {
    eight: "- If player completed a whole cycle of 5 days. ",
    eighteen: "Prize {number}",
    eleven: "By participating in the promotion, you automatically agree to these terms and conditions set out by the online casino running the promotion.",
    fifteen: "Goals and Prizes",
    five: "Rewards are growing with daily progression and intraday goals completion. In order to keep the daily progress player needs to complete Daily Goal at least once to be eligible entering the next day in the cycle and pretend for bigger rewards.",
    four: "Daily Rewards campaign runs in cycles of up to 5 calendar days each with ability to compete the Daily Goal up to 3 times.",
    fourteen: "Malfunction voids all pays and plays.",
    list: "Terms and Conditions:",
    nine: "Other than the price to make a spin, there is no additional cost to participate and receive rewards.",
    nineteen: "Daily goal сompleted once",
    one: "It's time to harvest premium cabbage in monetary terms!",
    seven: "- If players missed a day or haven’t completed the Daily Goal at least once",
    seventeen: "Daily Goals",
    six: "Player’s Daily Rewards cycle resets to the 1st day in 2 cases:",
    sixteen: "Day in Cycle",
    ten: "Only real money rounds can participate in the Daily Rewards.",
    thirteen: "{company} holds the right to cancel the Daily Rewards campaign for the indefinite term without any payments according to the current state of cycles.",
    three: "Prize pool: 1'160.00 EUR personal (сalculated as a max total personal prize pool if player completes all possible Daily Goals throughout duration of this campaign (3 full cycles)). All Booongo games are participating. The juiciest reward is coming on the last day of each cycle!",
    twelve: "Daily Rewards rules can be changed anytime.",
    twenty: "Daily goal сompleted twince",
    twentyFive: "up to 1160 euros per participant!",
    twentyFour: "Prize fund",
    twentyOne: "Daily goal completed 3 times",
    twentySix: "Date and time",
    two: "To take part, play any of the games provided by Booongo and reach your daily goals. The prize fund - up to 1160 euros per participant!"
  },
  cabinet: "Personal account",
  calculated: "Settled",
  calculationID: "Settlement ID",
  canNotChangeCurrency: "Can't change the currency",
  canSelectSavedData: "You can select saved data",
  cancel: "Cancel",
  cancelBonus: "Cancel bonus",
  cancelBonusConfirm: "Are you sure you want to cancel the bonus? In case of cancellation all bonus funds will be forfeited",
  cantEnterTheCode: "Can't enter the code?",
  carriedOut: "Carried out",
  cashBackSum: "Instant Cashback Amount",
  cashBoxApproveCode: "Confirmation code",
  cashBoxApproveCodeHint: "Will be required by cashier to confirm the withdrawal",
  cashBoxDeliveryText: "For your convenience, when your deposit/withdrawal amount is at least {0}, you can request a courier. To request a courier, contact us in telegram, login {1}",
  cashbackTitle: "Cashback",
  cashboxAddress: "Cash-desk address",
  casino: "Casino",
  casinoBonus: "Casino bonus",
  casinoLogin: "{name} login",
  categoryFromAtoZ: "Category from A to Z",
  change: "Change",
  changeData: "Change data",
  changeEmail: "Change email",
  changeMethod: "Change the method",
  changePassword: "Change password",
  changePhone: "Change number",
  changeStatusCode: "Change code status",
  changeTheEmail: "Change email",
  changeWallet: "Change wallet",
  changingEmail: "Change the email",
  changingPhone: "Change the number",
  checkRobotText: "To verify that you are not a robot, click on the \"I confirm\" button",
  checking: "Under review",
  chooseComfortableAddress: "Choose an address convenient for visiting",
  chooseDepositViaCryptocurrencyMethod: "Select the “Deposit via cryptocurrency” method",
  chooseVariantOrContinueEnter: "Select an option or continue entering",
  chooseVerificationMethod: "Choose a method to disable withdrawal confirmation with a code.",
  clear: "Clear",
  clearFavorites: "Clear favorites",
  clickCheckoutInHeaderOfSite: "Click \"Cash desk\" in the site header",
  clickHome: "Tap on “Home”",
  clickOnTheOddsYouLike: "By clicking on the odds you like, simply place quick bets in the pop-up window:",
  clickSelectFrontCoin: "Click “Select” next to the coin, for example “Tether TRC20\"",
  clickShare: "Click \"Share\"",
  clickToAttache: "Click to attach a file\n",
  clickTopMenuToBuyCrypto: "Click \"Buy Crypto\" in the top menu and select the payment method \"Bank Card\". Min. amount - 10.40 USD",
  close: "Close",
  code: "Code\n",
  codeAlreadySendFillIt: "We sent a confirmation code, please enter it in the input field",
  codeIsWrong: "The code is not correct",
  codeSend: "SMS code sent to phone number",
  codeSendToEmail: "Code sent to email",
  codeSendToPhone: "Code sent to phone number",
  codeSendToTelegram: "Code sent via Telegram bot",
  codeVerificationDisabled: "Code verification is disabled",
  codeVerificationEnabled: "Code verification enabled",
  coinSelection: "Coin selection",
  comboBoostBonus: {
    button: "Play",
    content_title: "How to use Combo Boost:",
    good_luck: "Olymp.casino wishes you big winnings!",
    range_left_title: "Number of events",
    range_right_title: "Odds",
    step_one: "Step 1:",
    step_one_description: "Start collecting your winning accumulator bet now and see how you can get increased odds.",
    step_three: "Step 3:",
    step_three_description: "When you've made your choice, place your bet! The bonus will automatically increase your final odds. You can check your bet in 'My bets'. It will be highlighted with a COMBOBOOST marker.",
    step_two: "Step 2:",
    step_two_description: "Keep collecting your accumulator bet and watch the bonus increase.",
    welcoming_range_title: "Find out your odds.",
    welcoming_text: "Olymp.casino has great news for all new customers! To make sure it works, try this feature yourself! Place an accumulator bet of 2 or more events with odds of 1.5 or higher to increase your final odds with our bonus. Keep in mind, the more events in the accumulator bet, the greater your bonus will be.",
    welcoming_title: "More events in EXPRESS more Bonus!"
  },
  commission: "Commission:",
  competitionAction: "Take part in the tournament by playing one of the following games",
  competitionMembers: "tournament participants",
  competitionParticipants: "The list of participants will be displayed here",
  competitionWinners: "The list of winners will be displayed here",
  competitions: "All tournaments",
  competitionsGames: "Tournament",
  competitors: "{count}  tournament participants",
  completeRegistration: "Complete registration",
  completeSecuritySettings: "Complete the security settings for your personal data and funds",
  completeSignIn: "Complete sign in",
  completed: "Tournament is over",
  conductError: "Error",
  confirm: "Confirm",
  confirmData: "Confirm data",
  confirmInformation: "Confirm information",
  confirmPersonalData: "I confirm the authenticity of the personal data and understand that this information cannot be changed",
  confirmPhoneNumber: "Confirm the phone number ",
  confirmPhoneThroughTelegram: "Go to the Telegram app and confirm the phone number for secure withdrawal of funds",
  confirmationCode: "Confirmation code",
  confirmationEmail: "Email confirmation",
  confirmationPhone: "Phone confirmation",
  confirmed: "Confirmed",
  congratulationsTrustWalletCreated: "Congratulations! Trust Wallet is created!",
  contact: "contact",
  continueSecuritySetup: "Return to Security Setting",
  converting: "automatically converted to",
  copeAddressMemo: "Memo copied successfully",
  copeAddressWallet: "Wallet address successfully copied",
  copeAddressWalletNew: "Your wallet address has been successfully copied",
  copeCode: "Code copied successfully",
  copeSumText: "Amount copied successfully",
  copy: "Copy",
  copyAddress: "Copy the address",
  copyCode: "Copy code",
  copyTheAddress: "Copy the address",
  countries: {
    bangladesh: "Bangladesh",
    kazakhstan: "Kazakhstan",
    kyrgyzstan: "Kyrgyzstan",
    russia: "Russia",
    uzbekistan: "Uzbekistan"
  },
  country: "Country selection",
  countryNotFound: "Country not found, please check spelling",
  countrySelect: "Country selection",
  coupon: "Coupon",
  couponContainsDependentOutcomes: "The coupon contains related outcomes",
  createWalletInTrustWallet: "Create a wallet in Trust Wallet",
  cryptoMemo: "Memo",
  cryptoTournament: "Crypto tournament",
  cryptoWallerSuccessChanged: "Wallet address changed successfully",
  cryptoWallet: "Crypto wallet",
  cryptocurrency: "Cryptocurrency",
  currency: "Currency",
  current: "Current",
  currentBalanceIsLessThanTheWithdrawalAmount: "Not all payment methods are available, the current balance is less than the minimum amount for a transaction",
  currentRates: "Current bets",
  customerSupport: "customer support",
  customizeDisplayedCoins: "To customize the coins displayed, click on the sliders in the top right corner. On the Add Tokens page, enter Doge in the search bar. Then, activate the Dogecoin by clicking on the slider next to it",
  cyrillicInPasswordNotAvailable: "Cyrillic characters are not allowed in the password",
  data: "Date",
  dataNotSpecified: "Data not specified",
  date: "Date",
  dateFrom: "Date from",
  dateOfTransaction: "Transaction date",
  dateTo: "Date until",
  deadline: "Finishes in",
  december: "December",
  decline: "Declined",
  demo: "Demo",
  deposit: "Deposit",
  depositAccount: "Deposit the account",
  depositBK: "Deposit from Bookmaker",
  depositBonus: "{bonus} bonus for deposit",
  depositForBonus: "Make a deposit in the amount from {sum} to receive the bonus",
  depositNoun: "Deposit",
  depositRequired: "You need to make a deposit from <span class='bonus-item__sum'>{sum}</span>",
  description: "Description",
  descriptions: {
    gameGroups: {
      "GamesByGroup\/slot": "Slots online ➔ play for ✓money, ✓free of charge and ✓without registration. {company} casino presents ✓free   ✓popular ✓modern slot machines, from ✓official provider, with ✓generous bonuses and ✓various subjects."
    }
  },
  details: "More details",
  docsWasApproved: "Documents successfully checked",
  docsWasDeclined: "The documents have not been verified",
  documentAttacheMessage: "We will check it within 24 hours. After that withdrawal methods will be available.",
  documentAttacheSuccess: "Your documents have been successfully sent.",
  documentDeleteSuccess: "Documents have been successfully deleted",
  documentNumber: "Document number",
  documentUpload: "Uploading documents",
  done: "Done!",
  doneThresholdConditions: "Conditions for deposit wagering are fulfilled",
  download: "Download",
  downloadApp: "Download the app",
  downloadOlimpApp: "Download Olimp App",
  download_app: "Download Olymp App",
  dropswins: {
    eight: "Draw of money prizes of 9000€ takes part randomly. Play to win! ",
    eighteen: "Rules",
    eleven: "Weekly Tournament Prize Table (Regular Weeks)",
    fifteen: "Daily Prizes Table",
    five: "EVERY DAY",
    four: "TOURNAMENT",
    fourteen: "Weekly Tournament Prize Table (Regular Weeks)",
    nine: "4 х 62 000€ weekly tournament",
    nineteen: " 1. This is an network Pragmatic PlayTM campaign. This campaign runs from 11.02.2021 to 17.11.2021 CET ( from 01:01 11.02.2021 to 00:59 18.11.2021 EET) <br> 2. The campaign is carried out in 10 stages, where each stage lasts 4 weeks.<br> 3. The total prize fund of the entire promotion is €4,000,000, which consists of 40 x 62,000 € weekly tournaments and 40 x 63,000 € weekly prize draws.<br> 4. Below are the conditions for stage 7 of this promotion. Please note that the mechanics of the tournament change depending on the stage.<br> 5. To take part in any Network Company Tournament or Draw, players should open any of the participating games and confirm the participation/agree to the rules.<br> 6. Four (4) weeks of tournaments and prize draws will be run as follows:<br> Week 27:  11.08.2021 at 20:01 -  18.08.2021 at 19:59 EET<br> Week  28:  18.08.2021 at 20:01 -  25.08.2021 at 19:59 EET<br> 7. Qualifying Games:<br> Wolf Gold™, Mustang Gold™, Sweet Bonanza™, John Hunter and the Tomb of the Scarab Queen™, Great Rhino Megaways™, John Hunter and the Book of Tut™, The Dog House™, The Dog House Megaways™, Chilli Heat™, Fruit Party™, Big Bass Bonanza™, Madame Destiny Megaways™, Gems Bonanza™, Wild Wild Riches™, Wild West Gold™, Gates of Olympus™, Power of Thor Megaways™, Buffalo King Megaways™, The Hand of Midas™, Floating Dragon Hold & Spin™, The Magic Cauldron – Enchanted Brew™, Heart of Rio™, Dragon Hot Hold and Spin™, Lucky Lightning™, 5 Lions Megaways™\" ",
    one: "Join the Drops & Wins Online Tournament from Pragmatic Play where everyone can be a winner!",
    seven: "Go to the top of the leaderboard by the highest single spin winnings. ",
    seventeen: "This tournament uses a mechanism that calculates the winnings multiplier so that participation in the tournament is fair for all players, regardless of the size of the bet. For example, if you place €2 and won €10, then your winning multiplier is five. In this case, you will receive five points. Go to the Top 1200 Leaderboards with the highest single spin winnings.",
    six: "Open games in offers, join the tournament and start to play (minimum bet stake is 0.50 euro)*",
    sixteen: "To automatically take part in the tournament and prize draws you only need to join the campaign once.",
    ten: "4 х 63 000€ weekly prizes draw",
    thirteen: "Reward",
    three: "PLAY",
    twelve: "Place",
    twenty: "Weekly tournaments",
    twentyfour: "Instant cashback",
    twentyone: " 1. The leaderboard is based on points, and points are awarded based on the highest winnings per spin achieved in any game participating in the tournament, taking into account the bet stake.<br> 2. The leaderboard is updated in real time and players can view the leaderboard at any time while playing any of the participating tournament games.<br> 3. In the event that two (2) or more players finish the tournament at the same position on the leaderboard, the higher place will be given to the player with that number of points first.<br> 4. Prizes are paid to players as a fixed amount.<br> 6. The weekly prize fund includes 1200 cash prizes totaling € 62,000.<br> 7. PLACE - WEEKLY PRIZES<br> 1. €10,000<br> 2. €5,000<br> 3. €2,000<br> 4-10. €1,000<br> 11-20. €500<br> 21-50. €200<br> 51-100. €100<br> 101-300. €50<br> 301-600. €20<br> 601-1200. €10 ",
    twentythree: " 1. During each week of the promotion seven (7) daily prize draws is hold. <br> 2. During each promotion one (1) one spin that meets the conditions can earn one (1) prize from the prize fund. <br> 3. Prizes are drawn on a random basis. Rules and prize tables are available in the participating in the tournaments games. The prize table is updated in real time, showing the current position as well as the number of prizes remaining. <br> 4. Prizes will be paid out as indicated on the Prizes tab for each of the participating in the tournaments games. <br> 5. Prizes are paid to players as a fixed amount. <br> 6. To take part in the prize draw, a minimum real money bet of € 0.50 must be placed on the game (s) participating in the tournament. One player can win several prizes during each day. <br> 7. Prize draw will end daily at (i) 00:59 EEST/EET or (ii) after all prizes have been awarded (whichever comes first). <br> 8. If the prize pool for a particular daily draw is not fully distributed, then any surplus funds will be transferred, at the discretion of PragmaticPlay ™, to the prize fund for the next stage. <br> 9. The weekly prize fund is € 63,000 in total and the daily prize fund includes 500 cash prizes and free spins totaling € 9,000. <br> 10. Quantity - Daily Prizes <br> 1 X € 1,000 <br> 2 X € 500 <br> 5 X € 100 <br> 12 X € 50 € 110 X € 20 € 370 X € 10 <br> 11. Winners receive their prizes in cash. Cash prizes will be automatically credited to their gaming accounts at {baseLink} Casino after the tournament ends. <br> 12. {baseLink} reserves the right to change or cancel the terms of the promotion at any time. <br> 13. General terms and conditions of  {baseLink} is applied. ",
    twentytwo: "Weekly prize draws",
    two: "The prize fund of €500,000 is distributed between stages - €125,000 per week! To take part, simply follow the steps below!"
  },
  email: "Email",
  emailNeedValid: "Verification code will be sent to your e-mail",
  emailSuccessfullyApproved: "Email successfully confirmed",
  emptyGames: "We didn't find such games for you",
  emptyPromoPage: "Current promotions will be displayed here",
  ended: "Completed",
  engineeringWorks: "After 5 minutes, technical work will be carried out on the site",
  english: "English",
  enter: "Join",
  enterCode: "Enter code",
  enterCodeFromEmail: "Enter the code from the e-mail",
  enterCorrectPhoneNumber: "Enter correct telephone number\n",
  enterCryptoWallet: "Enter crypto wallet",
  enterCryptoWalletOnProfilePage: "Enter Doge crypto wallet in your personal account to receive your winnings",
  enterGameName: "Enter the name of the game",
  enterGameNameOrProvider: "Enter the name of the game or provider",
  enterMoreCharacters: "Enter more symbols",
  enterPromoCode: "Enter promo code",
  enterSMS: "Enter code from SMS",
  enterSixDigitCode: "Enter the 6-digit code from the app",
  enterValidEmail: "Enter correct email",
  enterWalletAddress: "Enter your Doge crypto wallet address now or later to get your tournament winnings.",
  enterYourBankCardDetails: "Enter your bank card details, agree to the terms of the payment system and click “Pay”",
  entrance: "Log in",
  err404subtitle: "We are waiting for you on the main page!",
  err404title: "Unfortunately, nothing was found ...",
  error: "Error",
  errorPasswordField: "The password must contain numbers, uppercase and lowercase letters",
  errorPaymentDataInitialization: "Error when initializing the payment system",
  errorPaymentUrlInitialization: "Error when initializing payment",
  errorWhileSendingCode: "Sending message with the code failed, please try requesting it again",
  errorsWhileValidate: "Form validation errors",
  euro_slot: {
    description: "Euro Slots 2024 online play only at {platform} - the best official gaming slots. Play for free and for money in online casino.",
    end: "The tournament is over",
    "final": "Get to the final",
    inProgress: "The match is live",
    mathPrize: "Match prize fund:",
    onWallet: "to the account",
    prize: "Total prize fund:",
    "prize-short": "PRIZE",
    prizeFond: {
      "1\/2": "Prize fund of <p>Semi-finals:</p>",
      "1\/4": "Prize fund of <p>Quarter finals:</p>",
      "1\/8": "Prize fund of<p>1/8 finals:</p>",
      "final": "<p>Prize fund of final:</p>"
    },
    rules: {
      "1": "The promotion runs from 13.06.2024 00-00 GMT +5 to 14.07.2024 00-00 GMT +5",
      "2": "Total tournament prize fund: {sum}",
      "3": "According to the schedule, a battle is held among slots that move along the tournament grid",
      "4": "Users who made the greatest contribution to the victory of a particular promotional game distribute the prize fund among themselves",
      "5": "Dates for stage 1/8 couples ({sum}):",
      "6": "Dates for stage 1/4 couples ({sum}):",
      "7": "Dates for stage 1/2 couples ({sum}):",
      "8": "Final dates ({sum}):",
      "9": "Prizes are credited automatically to the game account within 24 hours"
    },
    stage1: "<span>Register</span> and click the “PARTICIPATE” button.",
    stage2: "<span>Bet on any</span> of the participating games and score points.",
    stage3: "<span>Top players</span> will share the total prize fund",
    stages: {
      "1\/2": "Semi-finals",
      "1\/4": "Quarter finals",
      "1\/8": "1/8 finals",
      "final": "Final"
    },
    stagesAtStart: {
      "1\/2": "The final starts in:",
      "1\/4": "The Semi-finals start in:",
      "1\/8": "The Quarter finals start in:",
      "final": "Final",
      pre: "The 1/8 finals start in:"
    },
    start: "How to participate",
    table: "Tournament table",
    title: "Euro Slots 2024 Tournament  - Play slots online at {platformSite} casino",
    winners: "Tournament winners"
  },
  events: "Events",
  exchangeRateInTenge: "Exchange rate in tenge",
  exit: "Exit",
  express: "Accumulator ",
  expressCoef: "Accumulator  odds",
  expressSystem: "Accumulators system",
  failed: "Action not taken",
  fastBet: "Quick bet",
  fastbetDetailedDescription: "Quick bet allows you to place single bets in just two clicks. Remembering the amount of the last bet speeds up the betting process even more.",
  fastbetSetting: "Quick bet settings",
  fastbetSum: "Quick bet amount",
  favorite: {
    added: "Game added to favorites",
    removed: "The game has been removed from favorites"
  },
  favorites: "Favourites",
  february: "February",
  fieldRequire: "Required field",
  fileAttached: "File attached",
  fileNotAttached: "File not attached",
  fillInformation: "Fill information",
  fillProfileInfoForWithdraw: "Please fill in your personal information to withdraw money.",
  fillRequiredInfoBelow: "Please fill in the information required below",
  filter: "Filter",
  filterByDate: "Filter by date",
  filtersText: {
    inTheNextSixHours: "within next 6 hours",
    inTheNextTwentyFourHours: "within next 24 hours",
    inTheNextTwoHours: "within next 2 hours",
    nextThreeDays: "within next 3 days",
    nextTwelveHours: "within next 12 hours",
    nextWeek: "within next week",
    today: "Today",
    tomorrow: "Tomorrow",
    whenever: "any time"
  },
  findOutAddressOfDogeWallet: "Find out the Doge wallet address",
  fine: "OK",
  firstAuthMessage: "An SMS with username and password was sent to the phone number. Deposit your account and get your first winnings\n",
  firstDeposit: "On first deposit!",
  forCorrectGamePushRefresh: "To display the game correctly, click the refresh button",
  forEndCompetition: "Until the end of the tournament",
  forMoreInformation: "For more information",
  forStartCompetition: "Before the tournament starts",
  forgotPassword: "Forgot password?",
  fraud: "AML Policy",
  freeBetsButton: "Read",
  freeBetsCount: "Free bets available:",
  freeBetsStepFour: "Place your bet",
  freeBetsStepOne: "Open the «Sports» section",
  freeBetsStepThree: "Select an event",
  freeBetsStepTwo: "Activate «Freebet» in the coupon",
  freeBetsTitle: "”Free bet” for sports",
  freeSpinsInGame: "Free Spins in a game",
  freespin: "Free spin",
  freespinsAvailable: "Free spins available",
  from: "from {date}",
  fromAnySum: "From any amount",
  fromNumber: "from",
  fromSmth: "From {value}",
  fulfillConditionsForWithdrawal: "Fulfill all conditions for withdrawal of funds.",
  fund: "Prize fund",
  future: "Future",
  game: "Game",
  gameDescTemplate: "{gameName} slot machine is an online slot from the well-known developer {providerName}. Play {gameName} slot machine for free or register to play for real money",
  gameForMoneyOnlyForAuthUser: "Playing for money is available only to authorized users",
  gameInOtherTab: "The game is open in another tab",
  gameNotAvailableBonus: "Game is unavailable due to bonus conditions",
  gameNotAvailableGeoRestriction: "The game is not available in your region",
  gameNotFound: "Game not found",
  gameTitleTemplate: "{gameName} slot machine. Play for free at {company} online casino",
  gameUnavailable: "The game is temporarily unavailable",
  game_categories: "Game categories",
  games: {
    tryOther: "Try other games"
  },
  gamesNotFound: "Games not found",
  geoRestrictionDesc: "Unfortunately, this game is not available in your region.",
  geoRestrictionDescLine2: "We suggest you choose another game from the catalog",
  get: "Get",
  getBonus: "Get bonus",
  getBonusByPromoCode: "Get a bonus by promo code",
  getGainFromFreeSpins: "Getting winnings from freespins",
  getNewCode: "Get new code\n",
  getSMS: "Get SMS code",
  go: "Go to",
  goBack: "Go back",
  goToGame: "Go to the game",
  goToGames: "Go to games",
  goToHome: "Go back to the main page",
  goToOlimpCasinoAndPlayFavoriteGames: "Go to Olimp Casino and play your favorite games:)",
  goToVolet: "Go to the volet.com (advcash) website",
  goToWallet: "Go to the wallet",
  goesNow: "Playing now",
  gold: "Gold",
  guarantee: {
    five: "Self-exclusion from the game. If, in order to reduce the desire to play, you contact our casino support service with a request to block your account, your request will be fulfilled. You also can irrevocably delete your profile. In another case, at the request of the player, it can be restored after some time.",
    four: "For players who want to restrict personal access to the game, the following options have been developed:",
    one: "Responsible Gaming",
    seven: "Access limitation. If you want to protect yourself from various web-sites that provide or advertise gambling, you should use special software. It filters the systems and ensures a safe online experience for users prone to gambling addiction. In addition, the software can be used to prevent children from accessing unwanted resources. Examples of this kind of software: Net Nanny (www.netnanny.com), CyberPatrol (www.cyberpatrol.com).(www.cyberpatrol.com).",
    six: "Specialized help. If gambling addiction develops, players can resort to the help of qualified specialists. You can be helped by: Gamblers Anonymous (www.gamblersanonymous.org.uk) - an international community of anonymous gamblers, providing assistance to addicted gamblers; GamCare (www.gamcare.org.uk) - an English-speaking organization that helps players to get rid of addiction; Gambling Therapy (www.gamblingtherapy.org) is a UK-based organization that provides qualified support in the fight against a common ailment.",
    three: "If you feel a little addicted to gambling, first of all find out what gambling is for you. If gambling is an attempt to escape from lifes difficulties, if it takes up almost all your free time and interferes with work, this is already the first hint. If you borrow money to play and no longer imagine your day without playing, this is a sure sign that you need drastic changes.",
    two: "{titlePure} has certain responsibilities towards the users who play on the web-site. The casino administration is ready to help players avoid possible consequences of gambling addiction. The point of the game is to deliver positive emotions and bring joy. Of course, failures can happen, but this in no case should cause any financial or social difficulties."
  },
  hasMinimalDeposit: "Minimum deposit made",
  haveActivatedFastbetMode: "You activated the quick bet mode. To view the rules, please click",
  haveNotEmailContactUs: "If you did not receive an email, please check your \"Spam\" and \"Promotions' folder or contact {0}",
  haveNotPhoneContactUs: "If you didn't receive an SMS to your phone number, please contact {0}",
  here: "Here",
  hiddenConditions: "Hidden conditions",
  hide: "Hide",
  hideBonusCondition: "Hide bonus terms",
  hideDetails: "Hide details",
  history: "History",
  historyBets: "Bet history",
  historyPayments: "Payment history",
  historyTransactions: "Transaction history",
  hotGame: "Hot",
  hotGames: "Hot games",
  hotToBuyCryptoCurrency: "How to buy cryptocurrency?",
  howCanBuyCryptocurrency: "How can I buy cryptocurrency?",
  howCreateCryptoWallet: "How to create a crypto wallet? ",
  howCreateWallet: "How to create a wallet?",
  howToCreateCryptoWallet: "How to create a crypto wallet?",
  howToFindOutWalletNumber: "How do I find out my wallet number?",
  howToInstallApp: "How to install the app?",
  howToViewMyCryptoWalletInOlimp: "How do I view my crypto wallet?",
  howTopUp: "How to deposit",
  howTransferCrypt: "How to transfer cryptocurrency",
  howTransferCryptStep1: "Log in to wallet or exchange",
  howTransferCryptStep2: "Find the selected {currency} coin",
  howTransferCryptStep3: "Paste the address of our wallet",
  howTransferCryptStep4: "Specify and send the amount",
  iPaid: "I deposited",
  idWasCopied: "You copied transaction id",
  inSettings: "in settings",
  information: "Information",
  informationConfirmWithdraw: "Confirm all your details for security and withdrawal. To change your email address or phone number, contact\n",
  informationConfirmWithdrawSupport: "support service\n",
  informationForUpdateProfileData: "To update your contact information, please contact support",
  installApp: "{0} for installing the app",
  installTrustWalletApp: "Install the Trust Wallet app",
  instant: "Instant",
  instantCash: "Cashback",
  instantCashback: "Instant cashback",
  instantWithdrawal: "Instant withdrawal",
  instantly: "Instantly",
  insufficientFundsAvailable: "Insufficient funds. Available:",
  invalidCryptoWallet: "Invalid wallet address",
  invalidDateFormat: "Invalid date format",
  invalidDateInterval: "The selected interval is incorrect",
  invalidStartDate: "Incorrect start date",
  iosWebAppInstruction: "iOS Instruction",
  jackpot: "Jackpot",
  jackpotGame: "With jackpot",
  january: "January",
  july: "July",
  june: "June",
  kazakh: "Kazakh",
  kycPolicy: "KYC Policy",
  latestGames: "Recent games",
  leftCount: "{count} left",
  leftDeposit: "{sum} left to deposit",
  licenseCuracao: "The contents of the website is owned and operated by Perantia N.V. (<a href='https://{domain}' target='_blank'>{domain}</a>) as a License Holder (Curacao license No. #365/JAZ). All rights reserved and protected by law.",
  lineOn: "Betting line for {date}",
  linkIsReady: "The link is ready",
  liveCashBackDesc: "{company} offers an exclusive bonus available only for VIP clients! Place bets on games from the “LIVE Casino” category and get Cashback on your account depending on the amount of lost bets!",
  liveCashback: "Live cashback\n",
  liveCashbackHistory: "Live cashback history",
  live_casino: "LIVE Casino",
  loading: "Loading",
  loadingLanguage: "Loading language",
  lobby: "Lobby",
  login: "Login",
  loginCopied: "Your login copied",
  loginErr: "{name} login must not contain letters!",
  loginTelegram: "Log in with Telegram",
  logoutFromSystem: "Sign Out",
  lose: "Lost",
  losers: "Lost",
  lottery: "Lottery",
  mainPage: "Main page",
  makeABet: "Place a bet",
  makeBet: "Place bet",
  makeDeposit: "Make a deposit",
  march: "March",
  matchClosed: "Match closed",
  matchEnded: "Match completed",
  matchNotFound: "Match not found",
  matchPlanned: "Match planned",
  matches: "Matches",
  maxBet: "Maximum bet",
  maxForExpress: "Maximum for accumulator ",
  maxLength: "Maximum field length {length}",
  maxOutput: "Minimum withdrawal amount",
  maxPay: "Maximum payment amount",
  maxSum: "Max. amount",
  maxValue: "Maximum value {value}",
  maxValueShort: "Max: {value}",
  maxWithdrawSum: "Maximum withdrawal amount",
  maximumPayment: "Maximum payment amount:",
  may: "May",
  messageSMS: "Enter code from SMS",
  messages: "New messages",
  middleName: "Middle name",
  minBet: "Minimum bet",
  minDepositForBonus: "Make a deposit at least {sum} to complete the step",
  minLength: "Minimum field length {length}",
  minLengthPassword: "Minimum password length {min} characters",
  minOutput: "Deposit term",
  minPay: "Minimal payment amount",
  minSum: "Min. amount",
  minValue: "Minimum value {value}",
  minValueShort: "Min: {value}",
  minimalDeposit: "Minimal deposit",
  minimalLengthOfCode: "Пожалуйста используйте {num} символов",
  minimalSum: "Minimum amount",
  minimumPayment: "Minimum payment amount:",
  minimumTransfer: "Minimum transfer amount to account:",
  modal_telegram: "In our channel you will find active bonuses and promotions, weekly draws and much more, and with the bot you will never lose access to the website!\n",
  more: "More",
  moveToBonus: "Go to bonus",
  moveToMessages: "Go to Messages",
  myBalances: "My balances",
  myBonuses: "My bonuses",
  name: "Name",
  namePerson: "Name",
  nameTheCheckout: "Tell the wallet address to the cashier",
  navGamesCat: {
    aviator: "Aviator",
    aviatrix: "Aviatrix",
    betGames: "Betgames",
    fantasy: "Fantasy",
    fast: "Instant",
    jetx: "JetX",
    line: "Sports",
    live: "LIVE",
    liveGames: "LiveGames37",
    lottery: "Lottery",
    online: "Live Casino",
    slot: "Slots",
    sportGames: "Sport games",
    table: "Table",
    turboGames: "Turbo games",
    vSport: "V-sport",
    virtualGames: "Virtual games",
    worldcup: "2022 World Cup\n"
  },
  navLinks: {
    bonuses: "Bonuses",
    home: "Home",
    homeCasino: "Casino",
    posts: "Posts",
    profile: "Profile",
    promo: "Promo",
    sport: "Sport",
    tournament: "Tournaments"
  },
  needConfirmProfileInformation: "To activate the bonus, confirm your information in the profile",
  needDeposit: "A deposit must be made",
  needSettingsSecurity: "Please pass the security settings",
  needToExecuteConditions: "Conditions must be met",
  never: "Never",
  "new": "New",
  new2: "New",
  newBonusAvailable: "You have a new bonus",
  newGame: "New",
  newMessage: "New message",
  newMessages: "New messages",
  newOne: "New",
  newVersionReloadPage: "The site version has been updated, refresh the page for correct operation",
  newYearPromocodes2025: {
    NY25DAY1: "50​ ​FS​ ​in​ Santa's​ ​Gift​ game",
    NY25DAY10: "Freebet​•​for​•​sports!",
    NY25DAY11: "50​ FS​ ​in​ Santa's​ ​Great​ ​Gifts​ game",
    NY25DAY12: "75​ ​FS ​​in​ Royal​ Xmass​ ​2​ game",
    NY25DAY13: "75%​ ​to​ ​the​ deposit​ and​ 75​ FS ​as​ a​ gift!",
    NY25DAY14: "100​ FS​ in​ Santa's​ Xmas​ Rush​ game",
    NY25DAY2: "Freebet​•​for​•​sports!",
    NY25DAY3: "50%​ to​ ​the​ deposit​ and​ 50​ FS​ as​ a​ gift!",
    NY25DAY4: "75​ FS​ ​in​ ​Buffalo​ Power:​ ​Christmas​ ​game",
    NY25DAY5: "75%​ to​ ​the​ ​deposit​ and ​75​ ​FS​ as​ a​ ​gift!",
    NY25DAY6: "75​ FS​ in​ ​Royal​ Xmass game",
    NY25DAY7: "100%​ to​ the​ ​deposit​ and​ 100​ ​FS​ as​ a​ gift!",
    NY25DAY8: "100​ FS ​in​ Sugar​ Rush​ Xmas​ ​game",
    NY25DAY9: "50%​ to​ ​the​ ​deposit​ ​and​ 50​ ​FS​ ​as​ a​ ​gift!"
  },
  next: "Next",
  nextGames: "Show more",
  no: "No",
  noAccount: "No account",
  noBetsInHistory: "There are no bets in your history",
  noConnectionTryAlready: "No internet connection. Connect to the Internet and try again.",
  noDeposit: "No deposit",
  noFavoritesYet: "There are no favorites yet",
  noMatchSelected: "No event is chosen or the line is empty!",
  noResults: {
    bets: "Your bets will be displayed here",
    bonuses: "The available bonuses will be displayed here",
    competitions: {
      active: "Active tournaments will be displayed here",
      all: "Active tournaments will be displayed here",
      ended: "Past tournaments will be displayed here",
      future: "Future tournaments will be displayed here"
    },
    gamesNotFound: "No games found",
    gamesSearch: "No games found for your request, please try another request",
    messages: "Your messages will be displayed here",
    payin: "You don't have available deposit methods",
    payout: "You don't have available withdrawal methods",
    simple: "No results",
    transactions: "Your transactions will be displayed here",
    withdraw: "Your withdrawal requests will be displayed here"
  },
  noSelectionsForBetting: "Not selected outcomes for betting",
  nomination: "Tournament nomination",
  nonBonusGame: "The game doesn't  participate in the bonus program. We'll switch you to the main account.",
  nonBonusGameBetsNotCountInVager: "The game does not participate in the bonus program. Bets do not count towards the bonus wager",
  nonBonusGameWithoutBalance: "The game doesn't participate in the bonus program. To play, deposit your main account.",
  notBonuses: "No active bonuses",
  notCompetition: "No active tournaments",
  notConfirmed: "Not confirmed",
  notDeposit: "There were no deposits",
  notEnoughEventsForExpress: "Not enough events for accumulator",
  notEnoughEventsForSystem: "Not enough events for the system",
  notEnoughMoneyToWithdraw: "Not enough money to withdraw",
  notEnoughVventsForSystem: "Not enough events for the system",
  notInterested: "Not interested",
  notLogin: "Enter your {name} login!",
  notNow: "Not now",
  notPass: "Enter password!",
  notSufficient: "not sufficient",
  notValidValue: "Incorrect value",
  notification: "Notification",
  november: "November",
  nowInLine: "Now in Sports",
  nowPlayed: "Now wagered",
  numberErr: "Please check the number provided during registration",
  numberOfWallet: "Wallet number",
  october: "October",
  onAccountBK: "On Bookmaker account",
  oneClick: "Multiply the pot in one click",
  online: "Online",
  onlyForYou: "Only for you",
  open: "Open",
  openAppTrustWallet: "Open the app. You can access two options: registering a new wallet or restoring an existing one by clicking the \"Create a New Wallet\" button",
  openEmail: "Open email",
  openGameNewTab: "To open the game, click on the button",
  openSafari: "Open in Safari",
  openSafariIfAnotherBrowser: "If you're in a different browser, open this page in Safari",
  openTelegramBot: "Open telegram bot",
  operations: "Operations",
  orders: "Orders",
  ordinary: "Single",
  ordinarySeries: "Single bets serie",
  other: "Others",
  otherSections: "Other sections",
  ourSocialMedia: "Our social networks",
  ourSocialMediaShort: "Our social networks",
  out: "Exit",
  output: "Withdrawal",
  outputModalTitle: "Withdrawal confirmation",
  outputSuccess: "Withdrawal completed successfully!",
  overallCoef: "Overall odds",
  page: "Page",
  pageErr: "Page not found",
  pageErrDesc: "Page deleted or address entered incorrectly",
  pageNotFound: "Page not found!",
  pageNotFoundDesc: "Page deleted or address entered incorrectly",
  participant: "Participant",
  participate: "Participate",
  passErr: "Forgot your password?",
  passMessage: "Password must contain numbers, uppercase and lowercase letters",
  passportIndex: "Passport number / ID",
  password: "Password",
  passwordChanged: "Password changed",
  passwordErr: "Join now",
  passwordNew: "New Password",
  passwordSuccess: "Password recovered successfully",
  passwordTheSame: "Your new password must be different from the current one",
  past: "Past",
  pay: "Payout",
  payBonusErr: "To buy a bonus, make a deposit of at least",
  payMethod: "Deposit method",
  payMethods: "Deposit methods",
  paymentMethod: "Payment method:",
  paymentSuccess: "Funds transfer completed successfully!",
  payoutPayTrxsExistsText: "To withdraw funds, please make at least one deposit",
  payoutThresholdStatusText: "To withdraw funds, please wager {count}",
  period: "Period",
  personInformationIsApprove: "Data accepted, account protected",
  personalArea: "Personal account",
  personalData: "Personal data",
  personalDataApproved: "Personal data verified",
  personalDataIsFilled: "Personal details are filled out",
  personalDataSuccessfullyEdited: "Your personal data has been successfully changed",
  phone: "Phone",
  phoneErr: "The phone number cannot contain letters!",
  phoneNum: "Phone number",
  phoneSuccessfullyApproved: "Phone successfully confirmed",
  pickUpBonus: "Get the bonus",
  place: "Place",
  placeAQuickBet: "Place quick bet?",
  places: "Prize places",
  placesCount: "{count} places",
  placesPrice: "Prize",
  play: "Play",
  playAviator: "Play Aviator",
  playBonus: "Congratulations, you have wagered the bonus! Withdrawal will be available after deposit of the balance in the amount of {count}",
  playBonusEnded: "The bonus is over. To continue the game, deposit your account with an amount of {count}",
  playForMoney: "Play for money",
  playGamesInCategoryes: "Play games from categories",
  playWithoutBonus: "Play without bonus",
  playingInAppMoreConvenient: "Play in the app more convenient",
  pleaseConfirmAgreementToTheTerms: "Please confirm your agreement with terms",
  pleaseConfirmInformation: "Please confirm with information",
  pleaseSelectOutcome: "Please select outcome",
  pleaseUseNumberOfCharacters: "Please use {num} characters",
  point: "Points",
  points: "no points | {n} point | point | {n} points {n}",
  postSMS: "Send SMS code",
  posts: "Messages",
  potentialWin: "Potential winnings",
  ppenFullBetHistory: "Open full bet history",
  preparedForRemoval: "Prepared for withdrawal (processing)",
  preview: "Preview",
  prize: "Prize",
  prizes: "Winners prizes",
  proceed: "Continue",
  processDeposit: "Deposit processing",
  processDepositDescription: "The payment has been sent and is being processed by the payment system. The period for depositing funds can be from several minutes to several days",
  processWagerFromBonusBalance: "Fulfilment of wager from bonus balance",
  processWagerFromDeposit: "Fulfilment of wager from deposit amount",
  processed: "In processing",
  processing: "Processing\n",
  promo: "Promotions",
  promoCodeActivationSuccess: "Promo code successfully activated",
  promoGames: "Bonus games",
  promoMaxBetExceeded: "The maximum bet amount that will be used for wagering {bet}{currency}",
  promoNotFound: "No active promotions",
  promocode: {
    activate: "Activate promo code",
    placeholder: "Promo code",
    title: "Promo code activation"
  },
  promocodes: {
    NY25DAY1: "50 FS in Santa's Gift game",
    NY25DAY10: "50 FS in Santa's Great Gifts game",
    NY25DAY11: "Freebet for sports!",
    NY25DAY12: "75 FS in Royal Xmass 2 game",
    NY25DAY13: "75% to the deposit and 75 FS as a gift!",
    NY25DAY14: "100 FS in Santa's Xmas Rush game",
    NY25DAY2: "50% to the deposit and 50 FS as a gift!",
    NY25DAY3: "Freebet for sports!",
    NY25DAY4: "75 FS in Buffalo Power: Christmas game",
    NY25DAY5: "75% to the deposit and 75 FS as a gift!",
    NY25DAY6: "75 FS in Royal Xmass game",
    NY25DAY7: "100% to the deposit and 100 FS as a gift!",
    NY25DAY8: "100 FS in Sugar Rush Xmas game",
    NY25DAY9: "50% to the deposit and 50 FS as a gift!",
    NYDAY1: "50 FS in Hell Hot 100 game",
    NYDAY10: "50% to the deposit and 50 FS as a gift!",
    NYDAY11: "Freebet for sports!",
    NYDAY12: "Freebets on Aviator",
    NYDAY13: "75% to the deposit and 75 FS as a gift!",
    NYDAY14: "100 FS in Sugar Rush Xmas game",
    NYDAY2: "50% to the deposit and 50 FS as a gift!",
    NYDAY3: "Freebet for sports!",
    NYDAY4: "Freebets on JetX",
    NYDAY5: "75% to the deposit and 75 FS as a gift!",
    NYDAY6: "75 FS in Twin fruits of Santa game",
    NYDAY7: "100% to the deposit and 100 FS as a gift!",
    NYDAY8: "100 FS in Sugar Rush Xmas game",
    NYDAY9: "50% to the deposit and 50 FS as a gift!"
  },
  promocodes2025: {
    NY25DAY1: "50 FS in Santa's Gift game",
    NY25DAY10: "Freebet​•​for​•​sports!",
    NY25DAY11: "50​ FS​ ​in​ Santa's​ Great​ ​Gifts​ game",
    NY25DAY12: "75 FS in Royal Xmass 2 game",
    NY25DAY13: "75% to the deposit and 75 FS as a gift!",
    NY25DAY14: "100 FS in Santa's Xmas Rush game",
    NY25DAY2: "Freebet​•​for​•​sports!",
    NY25DAY3: "50%​ ​to​ the​ deposit​ ​and​ ​50​ ​FS​ ​as ​a​ gift!",
    NY25DAY4: "75 FS in Buffalo Power: Christmas game",
    NY25DAY5: "75% to the deposit and 75 FS as a gift!",
    NY25DAY6: "75 FS in Royal Xmass game",
    NY25DAY7: "100% to the deposit and 100 FS as a gift!",
    NY25DAY8: "100 FS in Sugar Rush Xmas game",
    NY25DAY9: "50% to the deposit and 50 FS as a gift!"
  },
  promotionNotFound: "There is no such promotion",
  protectYouData: "Secure your personal data and funds",
  protection: "Privacy Policy",
  protectionSettingsMessage: "Account security settings are necessary to secure your funds and withdraw them safely",
  providers: "Providers",
  purchaseCryptocurrency: "Cryptocurrency purchase",
  putSend: "Get code",
  queue: "In the queue\n",
  reSendCode: "Resend code",
  read: "Read",
  readyForWithdrawOnCashier: "Ready for payment at the cash desk",
  receiveWithdrawalConfirmation: "Receive withdrawal confirmation by e-mail/Telegram",
  recomend: "Recommend for you",
  recovery: "Password recovery",
  recoveryEmailDesc: "To access your account, enter the e-mail you provided during registration",
  recoveryPassword: "Recover the password",
  recoveryPhoneDesc: "To access your account, enter the phone number you provided during registration",
  recoveryWord: "Recovery",
  refill: "Deposit",
  refresh: "Refresh",
  refreshPage: "Refresh the page",
  refund: "Refund",
  refundPolicy: "Refund Policy",
  refundWithdrawal: "Cancel withdrawal ",
  refundWithdrawalModalDesc: "Are you sure you want to cancel the bonus? If you proceed, all bonus funds will be forfeited",
  refundWithdrawalNoun: "Withdrawal cancelation",
  reg: "Join now",
  register: "Join now",
  registrationBonus: "Bonus for registration",
  rejected: "Declined",
  remainingPlay: "Remaining to wager",
  repeatPassword: "Repeat password",
  repeatTopUpDesc: "Payment failed? Shall we try it again?",
  replenishment: "Deposit",
  requirement: "Requirement",
  requisiteDesc: "To make a deposit, transfer {sum} to your account. To ensure a successful deposit, the transferred amount must exactly match the specified amount.",
  resend: "Re-send",
  resendCodeCanAfter: "Code can be resent in {0}",
  reset: "Reset",
  resetFilters: "Reset filter",
  resetIt: "reset it",
  responsibleGame: "Responsible Gaming",
  result: "Result",
  results: "Results",
  resultsSearch: "Search results",
  "return": "Refund",
  rollback: "Rollback",
  rules: "Terms & Conditions",
  rulesDescription: "Rules",
  rulesShort: "Rules",
  rulesTournament: "Tournament conditions and rules",
  russian: "Russian",
  sales: "Cashed out",
  save: "Save",
  schedule: "Schedule",
  scores: "points",
  search: "Search",
  searchProviders: "Provider name",
  seats: "Places",
  secretAnswer: "Answer to the security question",
  secretQuestion: "Security question",
  security: {
    five: "If you still have questions regarding data protection, please contact the online support service or send an email to {support}. We will be happy to assist you.",
    one: "We are publishing this data-protection provisions to show that we are committed to doing business by global standards.",
    seven: "Protection of information",
    six: "The services and information on the website are provided by the company \"Euromirbet d.o.o.\", Podgorica, Cetinjski put bb, reg. no. 5-0685623/1. In accordance with the recommendations of the Payment Card Industry Security Standards Council, to protect customer data, encryption is used at the transport level - TLS 1.2 and at the application level with the AES algorithm with a key length of 256 bits",
    three: "{titlePure} has an anti-spam policy. All emails sent to our players are related to their gaming accounts, and may also contain information about their new features in the casino and relevant promotional materials. The frequency of advertising mailings can vary and reach up to 3 letters per day. Players reserve the right to unsubscribe - in this case, you must contact the online support service or unsubscribe at any time by clicking on the appropriate link at the bottom of the letter. Information about your winnings and payments made by you is also strictly confidential and stored in a secure environment.",
    two: "We believe that good business relationships are built only on honesty and trust. Therefore, the confidentiality of your information is extremely important to us. You can enjoy the game knowing that we take all measures to ensure the safety of your transactions. Your name, postal address, e-mail address, phone number, date of birth, gender, IP address and other information is private and confidential and cannot be transferred, sold or distributed to third parties."
  },
  securityAnswer: "Security answer",
  securityQuestion: "Security question",
  securitySetting: "Security setting",
  selectAll: "Select all",
  selectApproveMethod: "Choose a withdrawal confirmation method",
  selectCountryToReceive: "Select a country to receive current offers and conditions in the region",
  selectPaymentCurrencyAndClickTopUpAccount: "Select the payment currency and click “Deposit”",
  selectProviders: "All games by selected providers",
  selectQuestion: "First select a question",
  selectVariable: "Select the suitable option",
  sellBet: "Cash out",
  send: "Send",
  sendCode: "Send code",
  sendCodeError: "The code cannot be entered, please contact",
  sendCodeErrorSupport: "support",
  sendCodeRepeat: "Send code again",
  sendCodeSuccess: "Code sent to phone",
  sendCodeSuccessEmail: "Code sent to email",
  sendConfirmationEmail: "We've sent a confirmation email to",
  sendConfirmationPhone: "We sent an SMS with a code to number {phone}",
  sendDocuments: "Send documents",
  sendSMS: "Send SMS code",
  sendedCodeToEmail: "Code sent to email <br> {email}",
  sendedCodeToPhone: "Code sent to the phone <br> {phone}",
  september: "September",
  serverErrorTryAgain: "Server error, please try again",
  serverErrorTryRefresh: "Server error, try updating",
  settlementCurrency: "Settlement currency",
  sgtv_bonus: {
    block_one_li_four: "Get 10 Freebets.",
    block_one_li_one: "To receive the bonus, you must have at least {sum} {currency} on your balance.",
    block_one_li_three: "Activate the bonus in the Lobby.",
    block_one_li_two: "To activate the bonus, go to any SGTV game.",
    block_one_title: "How to get your bonus:",
    block_two_li_eight: "A 20x wager is required to receive the bonus. The minimum wagering odds are 1.5.",
    block_two_li_eleven: "Olymp reserves the right to change or cancel the terms of the offer individually and at any time, as well as to decline any player without explanation.",
    block_two_li_five: "A new player is credited with 10 freebets worth {sum} {currency} when entering the Sport Games section.",
    block_two_li_four: "The bonus is added instantly. If the selected bonus has not been added, you must contact customer support before starting the game. If you start the game without a bonus, it will not be credited.",
    block_two_li_nine: "The maximum amount of winnings available for withdrawal from no deposit free bets and no deposit bonuses is - {sum} {currency}.",
    block_two_li_one: "The user is entitled to only one bonus.",
    block_two_li_seven: "The bonus is available within 3 days from the moment of activation.",
    block_two_li_six: "Free bets can be used in the games «Boxing», «Darts», «Bridge», «Shootouts», and «Nards».",
    block_two_li_ten: "Freebets can be used for bets on odds from 1.3 to 5",
    block_two_li_three: "To receive the bonus, you need to make a deposit in the amount of {sum} {currency}.",
    block_two_li_two: "Bonuses (freebets) are given to players who have never placed bets on SportgamesTV.",
    block_two_title: "Terms and Conditions:",
    important_text: "Important! If you start the game without activating the bonus, free bets will not be added later.",
    title: "Free bets for new players at SportGamesTV! Get 10 free bets in the games \"Nards\", \"Boxing\", \"Darts\", \"Bridge\", \"Shootouts\"."
  },
  shallWePlay: "Shall we play?",
  shortDescription: "Short description",
  show: "Show",
  showAll: "Show all",
  showBets: "Show bets",
  showCodeOnlyForOperator: "Don't give the confirmation code to anyone except the cashier",
  showGame: "Show game",
  showGames: "Show games",
  showMatchesStarting: "Show matches starting at:",
  showMoreGames: "Show more games",
  showTerms: "Show terms and conditions",
  showTransactions: "Show transactions",
  signUp: "Sign up",
  signUpAndVerifyVolet: "Sign up and complete the verification process in 15 minutes",
  signin: "Log in",
  silver: "Silver",
  slots: "Slots",
  smallDescription: "Brief description of the tournament",
  smsCode: "Get SMS code",
  smsInfo: "An SMS code will be sent to your number",
  smsSendingDesc: "Enter the code that we sent to the number",
  smsVer: "SMS verification of payments",
  smsVerDisabled: "SMS verification of payments disabled",
  smsVerEnabled: "SMS verification of payments enabled",
  socialAuthError: "Error during authorization via social nerwork",
  soonStarted: "Will start soon",
  sort: "Sort",
  spaceNotAvailableForField: "Spaces are not allowed in this field",
  specifyNumberYourPersonalCryptoWallet: "In the field, enter your personal crypto wallet number on Olimp.com.",
  spinsBeforeCrediting: "Number of spins before deposit:",
  sportErrorText: "We are currently updating the \"Sports\" section, but we will restore everything soon.",
  sports: "Sports",
  stakeHasBeenSuccessfully: "Your bet is successfully accepted!",
  startSecuritySetup: "Pass security setup",
  stateOfAnAccount: "State of account",
  status: "Status",
  statusAcc: "Account status:",
  statusOfTransaction: "Transaction status",
  statusSuccess: "Confirmed",
  statuses: {
    calculationInProgress: "Settlement in progress",
    inProcess: "In process",
    notPayed: "Not paid",
    payed: "Paid"
  },
  sub_telegram: "Subscribe to telegram",
  success: "The action was successful",
  successEnterTournament: "Great, you're in the tournament!",
  successPromoCode: "Promo code successfully activated",
  sufficient: "sufficient",
  sum: "Sum",
  sumBet: "Bet amount",
  sumMoreThanBalance: "The amount is more than on the balance",
  sumWithdraw: "Payout amount",
  support: "Support",
  supportContact: "Contact support",
  surname: "Surname",
  suspended: "Suspended",
  system: "System",
  table: "Table",
  tapOnHome: "Tap on the \"Home\", and then click \"Done\"",
  tapOnShareIcon: "Tap the \"Share\" icon in the menu at the bottom of the screen. A dialog box will open",
  term: "Deposit term",
  termEnrollment: "Deposit term",
  termFulfillment: "Term for fulfillment of conditions:",
  termsAndConditions: "Terms and conditions",
  termsAndConditionsList: "Terms and conditions",
  timeFulfill: "Time to fulfill the conditions:",
  timeRemaining: {
    txt: "There are {seconds} seconds left to get the code again",
    txtPay: "You can get a new code in {seconds}"
  },
  timeToActivateBonus: "Time for bonus activation",
  timer: {
    oneLetter: {
      day: "d",
      hour: "h",
      minute: "m",
      second: "s"
    },
    "short": {
      day: "day.",
      hour: "hour.",
      minute: "min.",
      second: "sec."
    }
  },
  tip: "Tips",
  titles: {
    cashback: "Cashback\n",
    dropsWins: "Drops and wins\n",
    err404: "The requested page does not exist",
    fraud: "Fraud protection",
    gameGroups: {
      "GamesByGroup\/slot": "Slots online - play slot machines for money, free of charge without registration"
    },
    home: "{titlePure}",
    profile: "Profile",
    protection: "Protection of information",
    responsibleGame: "Responsible Gaming",
    rules: "Terms & Conditions",
    tournaments: "Tournaments",
    work: "Technical work in progress"
  },
  to: "to {date}",
  toFindOutWalletAddressOfCoin: "To find out the wallet address of any coin, click on the desirable coin on the main screen. The coin's page with transaction history will be displayed",
  toPromoStart: "Before the start of the promotion",
  toSupport: "support",
  topLines: "Top Sports",
  topUp: "Deposit",
  topUpWith: "Deposit via",
  topupYourBalance: "To play for money, deposit your balance",
  total: "Total",
  tournament: "Tournament",
  tournamentCryptoReminderText: "To claim your winnings, don't forget to enter your Doge сrypto wallet in your personal account ",
  tournamentDescription: "Tournament description",
  tournamentEnded: "The tournament ended",
  tournamentGame: "The game takes part in a tournament",
  tournamentGames: "Tournament Games",
  tournamentMounth: {
    "01": "January",
    "02": "February",
    "03": "March",
    "04": "April",
    "05": "May",
    "06": "June",
    "07": "July",
    "08": "August",
    "09": "September",
    "10": "October",
    "11": "November",
    "12": "December"
  },
  tournaments: "Tournaments",
  transactionCopied: "You copied the transaction id",
  transactionSuccess: "Transaction completed successfully",
  transactionsIsNotExist: "You have not had any transactions yet",
  transactionsNotFound: "No transactions were found for the selected filters. Try editing the filter parameters or {0}",
  transfer: "Transfer",
  transferAccount: "Transfer to account",
  transferAmount: "Enter the transfer amount",
  transferAmount2: "Enter the transfer amount",
  transferSuccessfully: "Funds transfer completed successfully",
  transferTheMoneyAndWait: "Give the money to the cashier and wait for deposit",
  transitionDate: "Transaction date",
  transitionStatus: "Transaction status",
  transitionType: "Transaction type",
  turnOff: "Turn off",
  turnOn: "Turn on",
  turnOnState: "On",
  turnover: "Turnover",
  twoFactorAuth: "Two-factor authentication",
  typeOfTransaction: "Transaction type",
  uncalculated: "Unsettled",
  underCoinBalanceClickGetButton: "Under the coin balance, press the Get button. Then, copy the address by using the button or scanning the barcode",
  unexpectedErrorWriteToSupport: "An unexpected error occurred, but we will fix it soon.",
  unexpected_error_try_again: "Unexpected error, please try again",
  unhandledErrorTryToRefreshPage: "Unexpected error, please reload the page",
  unselect: "Remove selection",
  untilStartLeft: "Starts in",
  update: "Update",
  upload: "Download",
  uzbek: "Uzbek",
  verification: "Verification",
  verificationDeclined: "Your verification was declined. Please contact customer support",
  verificationDeclinedInfo: "The documents have not been verified. Please re-attach documents or contact customer service.",
  verificationInProgress: "Your verification is in progress. Please wait",
  verificationsSMSDesc: "To verify payments, confirm the phone number you provided during registration",
  verifyYourAccount: "Verify your account",
  virtuals: "Virtuals",
  wager: "Wager",
  wagerGame: {
    accessAfterRolePlay: "The game will be available after the bonus wager is completed\n\n",
    gamesWagering: "Games in which wagering is available",
    nowPlayed: "Now wagered",
    remainForPlay: "Remaining to wager"
  },
  wallet: "Wallet",
  walletCopied: "Wallet copied",
  walletId: "Wallet address",
  walletNotLinked: "Wallet not linked",
  way: "Withdrawal method",
  ways: "Withdrawal methods",
  wbCashboxActiveText: "To receive 100% for a deposit to a bonus account, deposit your account from {minSum}. The main account will be available after wagering the bonus.\n",
  wbCashboxNotActiveText: "To receive 100% for a deposit to a bonus account, activate the bonus in your personal account.\n",
  wbWaitOnProfile: "A welcome bonus is waiting for you in the \"Bonuses\" section of your account\n",
  welcomeBonus: "Welcome bonus",
  welcomeBonusCasino: "Welcome bonus casino",
  welcomeBonusDescription: "Hurry up to make the payment within an hour and receive an increased bonus <span class='text-accent'>125%</span> for your deposit and up to 250 free spins!",
  welcomeBonusSport: "Welcome bonus sport",
  welcomeBonusTitle: "+25% to Welcome bonus",
  win: "Victory",
  winnerPoints: "Victory:",
  winners: "Won",
  withAnIncrease: "If odds are higher",
  withDrawOrdered: "WIthdrawal is issued",
  withDrawOrderedDesc: "The funds will be credited to your specified account shortly.",
  withInstantCashback: "With instant cashback",
  withdraw: "Withdraw",
  withdraw2: "Withdraw to",
  withdrawBK: "Withdraw to the Bookmaker",
  withdrawFunds: "Withdrawal",
  withdrawMethod: "Withdrawal method",
  withdrawMethods: "Withdrawal methods",
  withdrawNoun: "Withdraw",
  withdrawPaymentInfo: "Withdrawal via Visa/Mastercard is only available to the cards linked to your login. You need to deposit your login with a Visa/Mastercard.",
  withdrawPerDayCountExceeded: "You can make up to 1 withdrawal every day",
  withdrawTelegramBot: "To withdraw funds, you have to start telegram bot and login to it",
  withdrawWithApprove: "Withdrawal of funds with code confirmation",
  withdrawWithCode: "Withdrawal of funds with confirmation code",
  withdrawal: "Withdrawal restrictions",
  withdrawalCompletedSuccessfully: "Withdrawal request generated",
  withdrawalOfFunds: "Withdrawal of funds with confirmation code",
  work: "Technical work in progress",
  writeToSupport: "Contact support",
  yes: "Yes",
  yesConfirm: "Yes, I'm sure",
  yesOfCourseIWant: "Yes, of course I want",
  yesRefundWithdrawal: "Yes, cancel withdrawal ",
  yesSure: "Yes, I deposited",
  you: "You",
  youAreAuthorized: "You are logged in\n",
  youAreParticipateInTheTournament: "You are participating in the tournament!",
  youDontHaveTransactions: "You have not had any transactions yet",
  youHaveNewMessage: "You have a new message",
  youHaveNotNewMessages: "You don't have any new messages",
  youHaveSmsVerification: "You have enabled verification of payments, to make a transfer, go through the verification by SMS",
  youTakePart: "You are participating",
  yourBalance: "Your balance",
  yourCasinoBonus: "Your casino bonus",
  yourCurrentEmail: "Your email now",
  yourCurrentPhone: "Your number now",
  yourEmail: "Your email",
  yourPersonalUniqueWalletIsDisplayedHere: "Your unique individual wallet for the coin you selected earlier will be displayed here. A special button or QR code enables you to copy the wallet address"
} 
